import { usePageFilter } from '../contexts/PageFilterContext';

/**
 * The text typed in the global search box at the top of the app (what
 * GlobalSearch hands to the page on screen, same as DataTable receives through
 * PageFilterContext). List pages that are not built on DataTable (card grids,
 * Music, Guidelines, Events, Favour assignments) call this to narrow their
 * own rows. Pages carry no search field of their own in the breadcrumb bar
 * (guarded by header/noSearchInBar.contract.test.ts); on the Procurement and
 * Venues lists the box shows a per-page placeholder
 * (utils/globalSearchPlaceholder.ts). Navigating to another page clears the
 * term (SearchProvider).
 * '' when nothing is typed or there is no search provider above.
 */
export function useHeaderSearch(): string {
  return usePageFilter();
}
